import React from 'react'
import FontAwesome from 'react-fontawesome'
import * as styles from './_FailureFaceMessage.scss'
import withStyles from 'isomorphic-style-loader/withStyles'
import PropTypes from 'prop-types';

class FailureFaceMessage extends React.Component {
  static propTypes = {
    message: PropTypes.string.isRequired
  };
  render () {
    return <span className={styles['failure-message']}>
      <FontAwesome
        className={styles['failure-face']}
        name='frown-o'
            />
            &nbsp;
      {this.props.message}
    </span>
  }
}

export default (FailureFaceMessage)
